// extracted by mini-css-extract-plugin
module.exports = {"icon":"Wistia-module--icon--3uNPR","video":"Wistia-module--video--1y0w3"};